import { NotFound } from '@ohpen/enso-ui';
import { withGuard } from '@ohpen/react-authz';
import { DefaultRedirect } from './DefaultRedirect';
import {
  ProductsPage,
  BaseRatesPage,
  FeesPage,
  ErcProfilesPage,
  ImportsPage,
  ExportsPage,
  ChangeRequestsPage,
  ExclusiveProductsPage,
  ExchangeRatesPage,
  ProcurationFeesPage,
  LenderPage,
  FirmsPage,
  BrokersPage,
} from '../pages';

export const ROUTES = {
  home: {
    path: '/',
    element: <DefaultRedirect />,
  },
  lender: {
    path: 'lender',
    element: withGuard(<LenderPage />, { permissions: ['lenders:view'], flags: ['enableLender'] }),
  },
  firms: {
    path: 'firms',
    element: withGuard(<FirmsPage />, { permissions: ['firms:view'], flags: ['enableFirms'] }),
  },
  brokers: {
    path: 'brokers',
    element: withGuard(<BrokersPage />, { permissions: ['brokers:view'], flags: ['enableBrokers'] }),
  },
  procurationFees: {
    path: 'procuration-fees',
    element: withGuard(<ProcurationFeesPage />, { permissions: ['procurationFees:view'], flags: ['enableProcurationFees'] }),
  },
  products: {
    path: 'products',
    element: withGuard(<ProductsPage />, { permissions: ['products:view'] }),
  },
  rates: {
    path: 'rates',
    element: withGuard(<BaseRatesPage />, { permissions: ['baseRates:view'] }),
  },
  exchangeRates: {
    path: 'exchange-rates',
    element: withGuard(<ExchangeRatesPage />, { permissions: ['exchangeRates:view'], flags: ['enableExchangeRates'] }),
  },
  fees: {
    path: 'fees',
    element: withGuard(<FeesPage />, { permissions: ['fees:view', 'feeProfiles:view'] }),
  },
  erc: {
    path: 'erc',
    element: withGuard(<ErcProfilesPage />, { permissions: ['ercProfiles:view'] }),
  },
  imports: {
    path: 'imports',
    element: withGuard(<ImportsPage />, { permissions: ['imports:view'], flags: ['enableImports'] }),
  },
  changeRequests: {
    path: 'change-requests',
    element: withGuard(<ChangeRequestsPage />, { permissions: ['changeRequests:view'] }),
  },
  exportTemplates: {
    path: 'exports',
    element: withGuard(<ExportsPage />, { permissions: ['exportTemplates:view'], flags: ['enableExports'] }),
  },
  exclusiveProducts: {
    path: 'exclusives',
    element: withGuard(<ExclusiveProductsPage />, { permissions: ['exclusivitySets:view'], flags: ['enableFirms'] }),
  },
  notFound: {
    path: '*',
    element: <NotFound />,
  },
};
